module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-note",
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Note")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the most important virtues of an officer is credibility. A military organization supposedly cannot win a war without credibility along the chain of command. It is therefore assumed that most - surely not all - of the debriefs quoted in this presentation are credible; latter accounts from biographies, interviews and memoirs are therefore mostly ignored in this presentation of ILAF operations during Operation HOREV. Largely, this book is not a narrative, a story or a tale but a plain presentation of ILAF operations, mostly from an Israeli perspective, along the timeline of HOREV. It is not fully complete; it is not absolutely accurate; it is certainly concise and perhaps precise; but it is the best possible effort at this point in time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shlomo Aloni")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 November 2013")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ee0102","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Note.vue
// module id = 69
// module chunks = 0